import { formatDecimal, formatEuro, formatMileage } from '@/features/vehicle';
import type { VehicleRange, VehicleRangeFacet } from './vehicleFilters';

type RangeFormat = {
    /** Without the unit — the „von“ of „von – bis“. */
    number: (value: number) => string;
    /** With the unit. */
    value: (value: number) => string;
    /** An end of the scale below the slider. */
    scale: (value: number) => string;
};

function formatYear(year: number): string {
    return String(year);
}

const FORMATS: Record<VehicleRangeFacet, RangeFormat> = {
    price: { number: formatDecimal, value: formatEuro, scale: formatEuro },
    mileage: { number: formatDecimal, value: formatMileage, scale: formatDecimal },
    year: { number: formatYear, value: formatYear, scale: formatYear },
};

/** „von – bis“ with the unit once, at the end: „5.000 – 30.000 €“. */
export function rangeLabel(facet: VehicleRangeFacet, range: VehicleRange): string {
    const format = FORMATS[facet];

    return `${format.number(range.min)} – ${format.value(range.max)}`;
}

/** One thumb, for screen readers: „30.000 €“. */
export function thumbLabel(facet: VehicleRangeFacet, value: number): string {
    return FORMATS[facet].value(value);
}

export function scaleLabel(facet: VehicleRangeFacet, value: number): string {
    return FORMATS[facet].scale(value);
}
